'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LiveChatAppIcon = function LiveChatAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 62 61"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M30.9999 54.0002C47.9366 54.0002 61.6666 41.9865 61.6666 27.1668C61.6666 12.3472 47.9366 0.333496 30.9999 0.333496C14.0632 0.333496 0.333252 12.3472 0.333252 27.1668C0.333252 35.6407 4.82237 43.1972 11.8332 48.1148L11.8333 52.1903C11.8333 53.3805 11.5561 54.5544 11.0238 55.619L10.6956 56.2755C10.1828 57.3011 9.44645 58.1986 8.54081 58.9019L6.67683 60.3495L12.6279 60.3495C13.8091 60.3495 14.9742 60.0766 16.0325 59.5521L18.3728 58.3921C19.1192 58.0222 19.8004 57.5331 20.3895 56.944L21.4166 55.9168L24.2885 53.3556C26.4485 53.7776 28.6945 54.0002 30.9999 54.0002Z",
    fill: "#0F77CC"
  }), React__default["default"].createElement("path", {
    d: "M21.05 37.8983V14.6564L32.0347 8V44L21.05 37.8983Z",
    fill: "white"
  }), React__default["default"].createElement("path", {
    d: "M35.2116 40.6163H39.8424L39.95 11.8829H35.2116V14.6009H37.3116L37.2577 37.9538H35.2116V40.6163Z",
    fill: "white"
  })));
};

var LiveChatAppIcon$1 = iconStyles()(LiveChatAppIcon);

module.exports = LiveChatAppIcon$1;
